import { DateTime } from "luxon";
import { safeDump } from "js-yaml";
import { isEqual, pick } from "../../utils/lodash";
import { getMentions } from "../reducers/interview/variablesUtilities";
import { MentionBuilder } from "../../models/builders/MentionBuilder";
import { MiddlewareType, StoreType, ActionTypes } from "../actions/types";
import {
    SET_VARIABLE_MENTIONS,
    AUDIO_RECORDING_START,
    AUDIO_RECORDING_STOP,
    CACHE_RECALL,
    CONNECTION_CONNECTED,
    CONNECTION_DISCONNECTED,
    CONNECTION_ERROR,
    CONNECTION_PROGRESS,
    CONNECTION_START,
    NAVIGATION_PAGE_READY,
    OPEN_UPLOADED_FILE,
    QUESTIONNAIRE_CHANGED,
} from "../actions";

function getEvent(store: StoreType, action: ActionTypes) {
    const time = DateTime.local().toJSDate().toISOString();
    switch (action.type) {
        case SET_VARIABLE_MENTIONS: {
            const { variableName, matrixIndex, builder } = action;
            const variableState = store.getState().interview.variables;
            const mentions = getMentions(variableState, variableName, matrixIndex);
            const newMentions = builder(new MentionBuilder(mentions)).build();
            // Check if mentions changed before logging.
            if (
                isEqual(
                    mentions.map((m) => pick(m, ["value", "openEnd"])),
                    newMentions,
                )
            )
                return null;
            return { time, ...action };
        }
        case AUDIO_RECORDING_START:
        case AUDIO_RECORDING_STOP:
        case CACHE_RECALL:
        case CONNECTION_CONNECTED:
        case CONNECTION_DISCONNECTED:
        case CONNECTION_ERROR:
        case CONNECTION_PROGRESS:
        case CONNECTION_START:
        case NAVIGATION_PAGE_READY:
        case OPEN_UPLOADED_FILE:
        case QUESTIONNAIRE_CHANGED:
            return null;
        default:
            return { time, ...action };
    }
}

/**
 * Logs state changes to the console.
 */
export const flowLogger: MiddlewareType = (store) => (next) => (action) => {
    const event = getEvent(store, action);
    // Skip ignored events.
    if (!event) return next(action);
    // Convert to YAML.
    const str = safeDump(event, {
        skipInvalid: true,
    });
    // tslint:disable-next-line:no-console
    console.log(`---\n${str}...`.trim());
    return next(action);
};
